export default __webpack_public_path__ + "using-shake-internally.jpg";